import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import { HOST_SERVER } from './configs';
import { parseJwtToken } from './commonFunctions';

export const useNotificationSocket = onNotification => {
  const onNotificationRef = useRef(onNotification);
  onNotificationRef.current = onNotification;

  useEffect(() => {
    let socket = null;
    let isCancelled = false;

    const setupSocket = async () => {
      const storedCreds = localStorage.getItem('login_credentials');
      

      let parsedUserId;
      let parsedBearerToken;
      let parsedCsrfToken;

      if (storedCreds) {
        try {
          const parsedCreds = JSON.parse(storedCreds);
          const { data, headers } = parsedCreds || {};
          const tokenResp = await parseJwtToken(data);
          if (tokenResp?.userId) parsedUserId = tokenResp.userId;
          if (data?.token) parsedBearerToken = data.token;
          if (headers?.['x-csrf-token']) parsedCsrfToken = headers['x-csrf-token'];
        } catch (e) {
          console.error('Error parsing stored credentials:', e);
        }
      }

      if (!parsedUserId || !parsedBearerToken || !parsedCsrfToken) {
        console.warn('Notification socket missing authentication credentials');
        return;
      }

      if (isCancelled) return;

      const requestHeaders = {
        "user_id": parsedUserId,
        "X-Bearer-Token": parsedBearerToken,
        "X-Csrf-Token": parsedCsrfToken,
      };

      const baseUrl = HOST_SERVER.endsWith('/') ? HOST_SERVER.slice(0, -1) : HOST_SERVER;
      socket = io(`${baseUrl}/notifications`, {
        path: '/notification-socket',
        transports: ['polling', 'websocket'],
        extraHeaders: requestHeaders
      });

      socket.on('connect', () => {
        console.log('Socket.IO notification connection established', socket.id);
        console.log('Connected with headers:', requestHeaders);
      });

      socket.on('connect_error', err => {
        console.error('Socket.IO connection error:', err);
      });

      socket.on('disconnect', () => {
        console.log('Socket.IO notification connection disconnected');
      });

      const handleNewNotification = data => {
        console.log('Real-time notification received:', data);
        if (onNotificationRef.current) {
          onNotificationRef.current(data);
        }
      };

      socket.on('new-notification', handleNewNotification);
      socket.on('alert', handleNewNotification);

      // Log all incoming events for debugging
      socket.onAny((event, ...args) => {
        console.log('Socket event received:', event, args);
      });
    };

    setupSocket();

    return () => {
      isCancelled = true;
      if (socket) {
        socket.disconnect();
      }
    };
  }, []);
};
